import React from 'react';
import { Booking } from '../components/Booking';
import { usePageTitle } from '../hooks/usePageTitle';
export function BookPage() {
  usePageTitle('Book Your Free Response Audit | Viridia Analytics');
  return <Booking data-id="element-457" data-mp="1buglqatic6hv" />;
}